import React, { useEffect, useState } from "react";
import Home from "./components/pages/home";
import forSeo from "./utils/seoTags";

function App() {
   return (
      <>
         <Home />
         {forSeo(
            "DishHome Nepal",
            "Dish Media Network | #1 DTH | IPTV | Internet | OTT | Data Center | Service provider of Nepal",
            "Dish Home is the leading DTH service provider in Nepal offering true digital HD TV channels. Get the experience of True HD with a range of affordable packages. ",
            "DishHome",
            `${process.env.REACT_APP_PUBLIC_URL}/offer_img.png`,
            process.env.REACT_APP_PUBLIC_URL,
         )}
      </>
   );
}

export default App;
